//============================================================================
// Name        : Settings.jsx
// Purpose     : Implement Manufacturing settings UI
// Created     : 2019-07-05
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";

import axios from "axios";
import React from "react";

const formStyle = css`
display: flex;
margin-bottom: 15px;
height: fit-content;
`;

const formGroup = css`
display: flex;
flex-direction: column;
justify-content: space-around;
margin-right: 15px;

& > div {
    font-size: 16px;
}
& > div, & > input {
    margin-bottom: 12px;
}
`;

declare var apiUrl: string;

interface ISettingsState {
    savedSuccess: boolean;
    savedError: boolean;
    showConfirmation: boolean;
    roPostingDateRangeBefore: string;
    roPostingDateRangeAfter: string;
    roQtyTolerance: number;
    roQtyToleranceUnder: number;
    priceFluctuationThreshold: number;
    adminOverridePassword: string;
}

export default class Settings extends React.Component<ISettingsState, ISettingsState> {
    constructor(props: ISettingsState) {
        super(props);

        this.state = {
            savedSuccess: false,
            savedError: false,
            showConfirmation: false,
            roPostingDateRangeBefore: this.props.roPostingDateRangeBefore ? this.props.roPostingDateRangeBefore : "",
            roPostingDateRangeAfter: this.props.roPostingDateRangeAfter ? this.props.roPostingDateRangeAfter : "",
            roQtyTolerance: this.props.roQtyTolerance,
            roQtyToleranceUnder: this.props.roQtyToleranceUnder,
            priceFluctuationThreshold: this.props.priceFluctuationThreshold,
            adminOverridePassword: this.props.adminOverridePassword
        };
    }

    onChange = (event: any) => {
        const newState = { [event.target.name]: event.target.value };
        this.setState(newState as ISettingsState);
    }

    onConfirmationClosed = () => {
        this.setState({ showConfirmation: false });
    }

    onSave = async () => {
        const data = {
            manufacturing_settings: {
                ro_posting_date_range_before: this.state.roPostingDateRangeBefore,
                ro_posting_date_range_after: this.state.roPostingDateRangeAfter,
                ro_qty_tolerance: this.state.roQtyTolerance,
                ro_qty_tolerance_under: this.state.roQtyToleranceUnder,
                price_fluctuation_threshold: this.state.priceFluctuationThreshold,
                admin_override_password: this.state.adminOverridePassword
            }
        };
        try {
            await axios.patch(apiUrl, data);
            this.setState({ savedSuccess: true, savedError: false });
        }
        catch (error) {
            console.log(error);
            this.setState({ savedSuccess: false, savedError: true });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.savedSuccess && <div className="alert alert-success">Settings updated successfully</div>}
                {this.state.savedError && <div className="alert alert-danger">There was an error saving changes</div>}

                <h2>Rename Common Field Names</h2>

                <div css={{ display: "flex", justifyContent: "left" }}>
                    <div css={formStyle}>
                        <div css={formGroup}>
                            <div>Order Posting Max Date Range Before</div>
                            <div>Order Posting Max Date Range After</div>
                            <div>Order Quantity Tolerance Above %</div>
                            <div>Order Quantity Tolerance Under %</div>
                            <div>Price Fluctuation Alert Threshold %</div>
                            <div>Admin Override Password</div>
                        </div>

                        <div css={formGroup}>
                            <input className="form-control" type="date"     name="roPostingDateRangeBefore"  value={this.state.roPostingDateRangeBefore} onChange={this.onChange} />
                            <input className="form-control" type="date"     name="roPostingDateRangeAfter"   value={this.state.roPostingDateRangeAfter} onChange={this.onChange} />
                            <input className="form-control" type="number"   name="roQtyTolerance"            value={this.state.roQtyTolerance} onChange={this.onChange} />
                            <input className="form-control" type="number"   name="roQtyToleranceUnder"       value={this.state.roQtyToleranceUnder} onChange={this.onChange} />
                            <input className="form-control" type="number"   name="priceFluctuationThreshold" value={this.state.priceFluctuationThreshold} onChange={this.onChange} />
                            <input className="form-control" type="password" name="adminOverridePassword"     value={this.state.adminOverridePassword} onChange={this.onChange} />
                        </div>
                    </div>
                </div>

                <button onClick={this.onSave} className="man-btn man-green-btn">Save</button>
            </React.Fragment>
        );
    }
}
